<div class="page-container">
    <div class="page-body-container">
        <div class="lg:px40 lg:gap-8 lg:px-40">
            <div class="home">
                <div class="header-line">
                    @if (user.id) {
                        <h1 class="text-center text-4xl font-bold self-center">
                            <span>Willkommen, </span><span class="text-preorder-background-top"> {{user.firstName}} {{user.lastName}}!</span>
                        </h1>
                    }
                </div>
                <div class="booking-line flex justify-center lg:pt-4 pt-8">
                    @if (user.id) {
                        <div class="flex lg:flex-row flex-col justify-center w-full lg:gap-30 gap-8">
                            <button class="btn-primary" [routerLink]="'/bestellungen'">
                                <span>Zur Bestellhistorie</span>
                            </button>
                        </div>
                    }
                </div>
            </div>
        </div>
    </div>
</div>



